import { useState } from "react";
import { ImageVisualizerElem } from "./ImageVisualizer.styles"
import dynamic from "next/dynamic";
import { VerticalSpacing } from "../VerticalSpacing";

const ImageLightbox = dynamic(() => import("./ImageLightbox"), { ssr: false });

interface ImageVisualizerProps {
    srcs: string[],
}

export const ImageVisualizer = ({ srcs }: ImageVisualizerProps) => {
    const [open, setOpen] = useState(false);
    const [opened, setOpened] = useState(false);

    return <>
        {
            srcs.map(src => <VerticalSpacing bottom={24} key={src}>
                <ImageVisualizerElem
                    src={src}
                    onClick={() => {
                        setOpen(true);
                        setOpened(true);
                    }}
                />
            </VerticalSpacing>)
        }
        {opened && <ImageLightbox srcs={srcs} open={open} onClose={() => setOpen(false)} />}
    </>
}